import request from '@/utils/request'
//get
export function getOrderByParam(param) {
    return request({
        url: `/order/${param}`,
        method: 'GET'
    })
}
export function getOrderByID(id) {
    return request({
        url: `/order/${id}/`,
        method: 'GET'
    })
}


// WEBPACK FOOTER //
// ./src/api/order.js